import { sendRequest } from 'best-modules/vue-utils'
import { Query } from 'best-modules/utils'
import {
  NumberReservation,
  NumberReservationCredentials,
} from '@/utils/types/documentRegistration'
import { PaginationList } from 'best-modules/components/server-table/types'

const numberReservationList = (
  query: Query
): Promise<PaginationList<NumberReservation>> => {
  return sendRequest({
    name: 'numberReservationList',
    method: 'get',
    url: {
      url: '/json/reserved-number',
      query,
    },
  })
}

const numberReservationPreview = (
  registrationJournalId: number
): Promise<{ registrationNumber: string }> => {
  return sendRequest({
    name: 'numberReservationPreview',
    method: 'get',
    url: {
      url: '/json/reserved-number/preview',
      query: { registrationJournalId },
    },
  })
}

const numberReservationCreate = (
  payload: NumberReservationCredentials
): Promise<NumberReservation> => {
  return sendRequest({
    name: 'numberReservationCreate',
    method: 'post',
    url: '/json/reserved-number',
    payload,
  })
}

const numberReservationDelete = (id: number): Promise<{ message: string }> => {
  return sendRequest({
    name: 'numberReservationDelete',
    method: 'delete',
    url: `/json/reserved-number/${id}`,
  })
}

export {
  numberReservationList,
  numberReservationPreview,
  numberReservationCreate,
  numberReservationDelete,
}
